import FileMisc from 'components/Icons/FileMisc';
import FileWord from 'components/Icons/FileWord';
import FilePdf from 'components/Icons/FilePdf';
import FileJpg from 'components/Icons/FileJpg';

// Common mime types can be found here -> https://developer.mozilla.org/en-US/docs/Web/HTTP/Basics_of_HTTP/MIME_types/Common_types

// eslint-disable-next-line
export const convertMimeIntoComponent = mimeType => {
  return (
    {
      'application/msword': <FileWord fontSize={27} color="#4b87e4" />,
      'application/vnd.openxmlformats-officedocument.wordprocessingml.document': (
        <FileMisc color="#4b87e4" />
      ),
      'application/pdf': <FilePdf fontSize={27} color="#e94335" />,
      'image/jpeg': <FileJpg fontSize={27} color="#2090bb" />,
    }[mimeType] || <FileMisc fontSize={23} color="#838383" />
  );
};
